require('./hireCardMaestroError.scss');

// @ vendors
const PropTypes = require('prop-types');
const React = require('react');

// @ helpers
const { FormattedText, formatText } = require('core/i18n').i18n;

// @ commons
const WizardError = require('components/commons/wizardError/wizardError');

class hireCardMaestroError extends React.Component {
    buildTexts() {
        const { isErrorAvailableAccounts, immHireCardMaestro, hireRestrictionFlag } = this.props;
        let errorMsg = immHireCardMaestro.get('errorMsg');

        let titleKey;
        let textElement;

        if (isErrorAvailableAccounts) {
            titleKey = 'hireCardMaestro-errorTitleGeneric';
            textElement = <FormattedText value="hireCardMaestro-notAvailableAccounts" />;
        } else if (!!errorMsg) {
            titleKey = 'hireCardMaestro-errorTitleNotAllowed';
            textElement = <FormattedText value={`hireDebitErrors-${errorMsg}`} />;
        } else {
            titleKey = 'hireCardMaestro-errorTitleGeneric';
            textElement = <FormattedText value="hireCardMaestro-errorTextGeneric" />;
        }
        if (isErrorAvailableAccounts && __CONTACT_CENTER__) {
            titleKey = 'hireCardMaestro-errorTitleNotAvailableAccounts';
            textElement = <FormattedText value="hireCards-errorTextNotAvailableAccounts" />;
        }
        if(hireRestrictionFlag){
            titleKey = 'hireCard-errorRestrictionTitleAccount';
            textElement = <FormattedText value="hireCard-errorRestrictionSubtitleAccount"/>;
        }
        return {
            textElement,
            titleKey
        };
    }

    render() {
        const { processDetail, hireRestrictionFlag } = this.props;
        const { textElement, titleKey, isErrorAvailableAccounts } = this.buildTexts();
        const goBackButton = hireRestrictionFlag ? {
            label: (
                <FormattedText
                    value="hireCard-errorRestrictionBackButtonText"
                />
            ),
            url: '/myprofile/global'
        }:
            isErrorAvailableAccounts && __CONTACT_CENTER__
            ?
                {
                    label: (
                        <FormattedText
                            format="uppercase"
                            value="hireCards-backButtonLabel"
                        />
                    ),
                    url: '/myprofile/cards'
                }
            :
                {
                    label: (
                        <FormattedText
                            format="uppercase"
                            value="hireCardMaestro-errorBackButtonText"
                        />
                    ),
                    url: '/myprofile/global'
                }
                const cancleButton={
                    label: (
                        <FormattedText
                            value="hireCard-errorRestrictionCancleButtonText"
                        />
                    ),
                    url: '/myprofile/cards'
                    };
        return (
            <WizardError
                errorMessage={formatText(titleKey)}
                mainButton={goBackButton}
                processDetail={processDetail}
                cancleButton={cancleButton}
            >
                <article className="hire-card-maestro-error">
                    {textElement}
                </article>
            </WizardError>
        );
    }
}

hireCardMaestroError.propTypes = {
    isErrorAvailableAccounts: PropTypes.bool,
    immHireCardMaestro: PropTypes.object.isRequired,
    processDetail: PropTypes.string,
    hireRestrictionFlag: PropTypes.bool
};

hireCardMaestroError.defaultProps =
{
    hireRestrictionFlag : false
}

module.exports = hireCardMaestroError;
